import naja from 'naja';
import ProductCategoriesExtension from "@weseus/cms-eshop-categories/assets/js/front/productCategories.naja";
import CategoryFiltersExtension from "./component/categoryFilters";
import CategoryInfScroll from "./component/categoryInfScroll";
import CategoryPageAnchor from "./component/categoryPageAnchor";
import WatchdogChoices from "./component/watchdogChoices";

naja.registerExtension(ProductCategoriesExtension);
naja.registerExtension(CategoryFiltersExtension);
naja.registerExtension(CategoryInfScroll);
naja.registerExtension(CategoryPageAnchor);
naja.registerExtension(WatchdogChoices);